/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { ReorderClassroomDisFoldersRequestViewModel } from "../types/ReorderClassroomDisFoldersRequestViewModel.ts";
import { reorderClassroomDisFolderItemViewModelSchema } from "./reorderClassroomDisFolderItemViewModelSchema.ts";

export const reorderClassroomDisFoldersRequestViewModelSchema = z.object({
  items: z
    .array(z.lazy(() => reorderClassroomDisFolderItemViewModelSchema))
    .nullish(),
}) as unknown as ToZod<ReorderClassroomDisFoldersRequestViewModel>;
